import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import { FormattedMessage } from 'react-intl'
import styles from './_findYourPathAnywhere.css'
import routes from 'images/app-page/find-your-path-anywhere/routes.png'

function FindYourPath () {
  return (
    <div className={styles.findYourPathAnywhere}>
      <div className={styles.content}>
        <Title align="center">
          <FormattedMessage id='appPage.findYourPathAnywhere.title' defaultMessage='Find Your Path Anywhere' />
        </Title>
        <Caption align="center">
          <FormattedMessage
            id='appPage.findYourPathAnywhere.caption'
            defaultMessage='Discover new routes wherever you are, and load your saved favorites.'
          />
        </Caption>
      </div>
      <div className={styles.routes}>
        <img src={routes} />
      </div>
    </div>
  )
}

export default FindYourPath



// WEBPACK FOOTER //
// ./src/components/app-page/find-your-path-anywhere/index.jsx